import { apiClient } from '@api';
import { ActiveRefill } from '@qmd-types/orders';
import { PatientAddress } from '@qmd-types/patient';
import { Adyen } from '@quickmd-llc/design-system';

type CreateRefillParams = {
  creditCardId: string;
  address: PatientAddress;
};

export async function createRefill(
  params: CreateRefillParams,
  adyenIsEnabled: boolean,
): Promise<void> {
  await apiClient.post<ActiveRefill>(
    `/api/v1/orders/refill${Adyen.getAdyenQueryString(adyenIsEnabled)}`,
    params,
  );
}

export async function fetchActiveRefill(): Promise<ActiveRefill> {
  const { data } = await apiClient.get<ActiveRefill>('/api/v1/orders/refill');

  return data;
}
